export const selectTalentQ = state => state.talentQ;
